// @ts-nocheck
import { Plugin } from '/builds/msfund/msvc-web/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
